export enum CoreTransaction {
  TRANSFER = "transfer",
  COMMENT = "comment",
  DELETE_COMMENT = "delete_comment",
  ACCOUNT_UPDATE = "account_update",
  ACCOUNT_UPDATE2 = "account_update2",
  ACCOUNT_CLAIM = "account_claim",
  CLAIM_ACCOUNT = "claim_account",
  ACCOUNT_CREATE = "account_create",
  AUTHOR_REWARD = "author_reward",
  COMMENT_BENEFACTOR_REWARD = "comment_benefactor_reward",
  CUSTOM_JSON = "custom_json",
  VOTE = "vote",
  CLAIM_REWARD_BALANCE = "claim_reward_balance",
  CURATION_REWARD = "curation_reward",
  DELEGATE_VESTING_SHARES = "delegate_vesting_shares",
  WITHDRAW_VESTING = "withdraw_vesting",
  WITHDRAW_VESTING_ROUTE = "set_withdraw_vesting_route",
  TRANSFER_TO_VESTING = "transfer_to_vesting",
  TRANSFER_TO_SAVINGS = "transfer_to_savings",
  ACCOUNT_WITNESS_VOTE = "account_witness_vote",
  LIMIT_ORDER_CREATE = "limit_order_create",
  LIMIT_ORDER_CANCEL = "limit_order_cancel",
  FEED_PUBLISH = "feed_publish",
  PRODUCER_REWARD = "producer_reward",
}
